<template>
  <div>
    <div>
      <!-- 商品主图 -->
      <img src="../../assets/imgs/home/goback.png" alt class="back-but" @click="$router.go(-1)" />
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in slideImgs" :key="index">
          <img :src="item" class="van-img" node="aspectFit" />
        </van-swipe-item>
      </van-swipe>
      <div class="detailsMid">
        <div class="salePrice">
          <div>
            ￥{{goodsDetail.price}}
          </div>
          <!-- <div class="priceBefore" v-if='goodsDetail.rank_price!=goodsDetail.price'>
            ￥{{goodsDetail.price}}
          </div> -->
        </div>
        <div class="goodsName">{{goodsDetail.name}}</div>
        <div class="goodsBtm">
          <div>
            快递:{{goodsDetail.freight}}元
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="gap"></div>
    <div class="detailsDesc">
      <div class="detailsDesc-title">—宝贝详情—</div>
      <div v-html="goodsDetail.content"></div>
    </div>
    <div class="popBtn">
      <van-goods-action>
        <!-- <van-goods-action-button type="warning" color="#FF784F" @click="carShow=true" text="加入购物车" /> -->
        <van-goods-action-button type="danger" color="#FA4D45" @click="carShow=true" text="立即购买" />
      </van-goods-action>
    </div>
    <van-action-sheet v-model="carShow" title="选择规格" :close-on-popstate="true">
      <div class="car-nav">
        <div class="car-nav-top">
          <div class="nav-top-left">
            <img :src="goodsDetail.image" alt style="	width: 80px;
					height: 80px;
					border-radius: 8px;" />
          </div>
          <div class="nav-top-right">
            <div>
              <span style="color: #FF3333;font-size: 15px;">￥{{goodsDetail.price}}</span>
            </div>
            <!-- <div style="color: #999;font-size: 13px;margin-top:10px;">
              每人限购<span style="color:#FF3333;">{{goodsDetail.purchase_limits}}</span>件
            </div> -->
            <div style="color:#333 ;margin-top: 12px;">请选择商品规格</div>
          </div>
        </div>
        <div class="car-nav-bot">
          <div :class="index==checked?'nav-bot-checked':''" v-for="(item,index) in attributes" :key="index"
            @click="checkgoods(item,index)">{{item}}</div>
        </div>
        <div>
          <div style="display: flex;color: #333;align-items: center;justify-content: space-between;">
            购买数量
            <van-stepper v-model="shop.nums" max='1' :disable-input="true"/>
          </div>
        </div>
        <div style="margin-top: 60px;">
          <van-goods-action>
            <!-- <van-goods-action-button type="warning" color="#FF784F" @click="addCar" text="加入购物车" /> -->
            <van-goods-action-button type="danger" color="#FA4D45" @click="onBuyClicked" text="立即购买" />
          </van-goods-action>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
  import { goodsDetail, addCart, goodsEvaluate } from "@/api/home";
  export default {
    data() {
      return {
        active: 0,
        slideImgs: [], //商品轮播图
        goodsDetail: {},
        slides: [],
        goodsId: "",
        carShow: false,
        checked: 0,
        shop: {
          attributes: "",
          nums: ""
        },
        rankOne: {},
        rankTwo: {},
        attributes: [],
        goodstype: [],
        evaList: [],
        count: 0
      };
    },
    created() {
      if (this.$route.query.id) {
        localStorage.setItem("goodsId", this.$route.query.id);
      }
      this.goodsId = this.$route.query.id || localStorage.getItem("goodsId");
      this.getData();
    },
    methods: {
      // 头部点击
      getItem(name) {
        console.log(name);
        if (name == 0) {
          window.scrollTo(0, 0);
        } else if (name == 1) {
          console.log('评价::::');
          // window.scrollTo(0,405);
          // window.scroll(0,200);
          this.$nextTick(() => {
            // document.body.scrollTop(0, 200);

          });

        } else if (name == 2) {
          window.scrollTo(0, 670);
        }

      },
      checkgoods(item, index) {
        this.checked = index;
        this.shop.attributes = item;
      },
      getData() {
        goodsDetail(this.goodsId).then(res => {
          let arr = [];
          let image = [];
          this.attributes = res.attributes.split(",");
          this.slideImgs = res.images.split(",");
          this.goodsDetail = res;
          this.shop.attributes = res.attributes.split(",")[0];
        });
      },
      Clickstar(value) {
        if (value == 0) {
          this.starform.type = 1;
        } else {
          this.starform.type = 0;
        }
        collectionStatus(this.starform).then(res => {
          this.getlist();
        });
      },
      changesku(value) { },
      // 加入购物车
      addCar() {
        if (this.shop.attributes == "") {
          this.$toast("请选择商品规格");
          return;
        }
        let data = {
          goods_id: this.$route.query.id,
          attribute: this.shop.attributes,
          number: this.shop.nums
        }
        addCart(data).then(res => {
          this.carShow = false;
        })
      },
      onClickLeft() {
        this.$router.push("home");
      },
      onBuyClicked() {
        if (this.shop.attributes == "") {
          this.$toast("请选择商品规格");
          return;
        }
        let data = this.goodsDetail;
        (data.nums = this.shop.nums), (data.attributes = this.shop.attributes);
        this.$router.push({
          path: `payOrder`
        });
        localStorage.setItem("chooseGoods", JSON.stringify(data));
      },
      toShowShopCar() {
        this.show = true;
      },
      goShowPay() {
        this.show = true;
      },
      // 选择规格
      getSize(item, index) {
        this.activeIndex = index;
        this.chooseSize = item;
      },

      chooseShow() {
        this.show = true;
      }
    }
  };
</script>
<style lang="less" scoped>
  .back-but {
    width: 8px;
    height: 16px;
    position: absolute;
    z-index: 9;
    top: 15px;
    left: 15px;
  }

  .van-button--default {
    width: 50%;
    border-radius: 25px 0 0 25px;
    color: white;
    background: -webkit-linear-gradient(left, #ffd01e, #ff8917);
    width: 50%;
    border: none;
  }

  .van-button--primary {
    width: 100%;
    border-radius: 25px;
    background: #fe881e;
    background: -webkit-linear-gradient(left, #ff6034, #ee0a24);
    border: none;
  }

  .car-nav {
    padding: 15px;

    .car-nav-bot {
      padding: 10px 0 15px 0;
      display: flex;
      justify-content: flex-left;
      flex-wrap: wrap;

      div {
        margin-top: 5px;
        padding: 0 6px;
        background: #e5e5e5;
        margin-left: 5px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        text-align: center;
      }

      .nav-bot-checked {
        background: rgba(165, 217, 181, 1);
        color: #02ac36;
        border: 1px solid #02ac36;
      }
    }

    .car-nav-top {
      display: flex;
      justify-content: start;
      align-items: center;

      .nav-top-right {
        margin-left: 10px;
        color: #ff6a19;
      }
    }
  }

  .check {
    color: #ff6b1a;
    border-bottom: 1px solid #ff6b1a;
  }

  .van-img {
    width: 100%;
    height: 301px;
  }

  .salePrice {
    display: flex;
    align-items: center;
    margin-bottom: 11px;

    div {
      color: #FF3333;
      font-size: 18px;
    }
  }

  .priceBefore {
    margin-left: 14px;
    font-size: 11px !important;
    border: 1px solid #999 !important;
    padding: 0 6px;
    height: 14px;
    color: #999 !important;
    text-align: center;
    line-height: 15px;
    border-radius: 4px;
    text-decoration: line-through;
  }

  .goodsPrice {
    color: #999999;
    font-size: 11px;

    span {
      text-decoration: line-through;
      margin-left: 5px;
    }
  }

  .detailsMid {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 24.5px;
    color: #333;
    font-size: 13px;

    .goodsName {
      display: flex;
      color: #333333;
      font-size: 13px;
      margin-top: 9px;
    }

    .goodsBtm {
      display: flex;
      color: #999999;
      font-size: 13px;
      margin-top: 9px;

      div {
        &:last-child {
          margin-left: 21px;
        }
      }
    }

    .goodsSize {
      margin-top: 11px;

      span {
        color: #999;

        &:last-child {
          margin-left: 33px;
        }
      }
    }
  }

  .gap {
    width: 100%;
    height: 8px;
    background: #f6f3f7;
  }

  .van-popup {
    font-size: 13px;
    color: #999;
  }

  .popBtn {
    padding: 0 15px;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    height: 52.5px;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .detailsDesc {
    font-size: 15px;
    box-sizing: border-box;

    .detailsDesc-title {
      padding: 10px 0;
      text-align: center;
      color: #666666;
    }

    /deep/ img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  /* 评价 */
  .evaluateNum {
    width: 100%;
    padding: 0 15.5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    font-size: 13px;

    .moreImg {
      width: 6px;
      height: 9.5px;
      margin-left: 6px;
    }

    .numLeft {
      color: #666;
    }

    .numRight {
      color: #FA4D45;
      display: flex;
      align-items: center;
    }
  }

  .evaList {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 13px;

    .evaItem {
      padding: 10px 0 14px 5px;
      box-sizing: border-box;
      border-bottom: 1px solid #f5f5f5;

      .itemTop {
        margin-bottom: 6px;
        display: flex;
        align-items: center;

        img {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }

      .evaCon {
        margin-left: 30px;
      }
    }
  }
</style>